<template>
  <div id="app">

    <!-- <div class="workspace">
      <h2>Workspace</h2>
      <h3>{{ $store.state.workspaceItems.length }}</h3>
    </div> -->

    <div id="nav" :class="{minimise : $store.state.navBarMinimised, 'modal--active' : $store.state.navBarModalActive }">
      <router-link class="tab_bar--placeholder" to="/"></router-link>
      <router-link class="tab_bar--placeholder" to="/about"></router-link>
      <router-link class="tab_bar--create" to="/s3"></router-link>
      <router-link class="tab_bar--placeholder" to="/s4"></router-link>
      <router-link class="tab_bar--placeholder" to="/s5"></router-link>
    </div>

    <!-- <main> -->
      <router-view/>
    <!-- </main> -->
  </div>
</template>


<script>
export default {
  computed: {
  }
}
</script>


<style scoped>
.workspace {
  align-items: center;
  background-color: #f7f7f7;
  bottom: 48px;
  box-shadow: 0 -2px 2px rgba(0,0,0,0.12);
  display: flex;
  height: 56px;
  justify-content: space-between;
  left: 0;
  position: fixed;
  width: 100%;
  z-index: 1000;
}
.workspace h2 {
  font-size: 20px;
  line-height: 56px;
  margin-bottom: 0;
  padding-left: 16px;
}
.workspace h3 {
  background: #666;
  border-radius: 3px;
  color: #fff;
  display: block;
  font-size: 18px;
  font-weight: 600;
  height: 24px;
  line-height: 24px;
  margin-right: 1rem;
  text-align: center;
  width: 24px;
}


#app {
  /*bottom: calc(0 + env(safe-area-inset-bottom));
  left: 0;
  position: fixed;
  right: 0;
  top: calc(0 + env(safe-area-inset-top));*/
}

#nav {
  background-color: #fafafa;
  border-top: 0.5px solid #ccc;
  bottom: 0;
  display: flex;
  padding-bottom: env(safe-area-inset-bottom);
  position: fixed;
  transition: 0.5s transform ease;
  width: 100%;
  z-index: 1000;
}
#nav.modal--active {
  z-index: 0;
}
.minimise {
  transform: translateY(100%);
}
#nav a {
  align-items: center;
  border-radius: 4px;
  display: flex;
  font-weight: 500;
  height: 48px;
  justify-content: center;
  /*margin: 3px;*/
  width: 20%;
}
.icon--create {
  height: 36px;
  width: 36px;
}
.tab_bar--create {
  background: url('/img/tab_bar--create.svg') no-repeat center center;
  background-size: 32px;
}
.tab_bar--placeholder {
  background: url('/img/tab_bar--placeholder.svg') no-repeat center center;
}

#nav a.router-link-exact-active.tab_bar--placeholder {
  background: url('/img/tab_bar--placeholder--active.svg') no-repeat center center; 
}
</style>


